exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-number-wrap {\n  margin-left: 2px;\n  margin-right: 2px;\n  background-color: rgba(118, 228, 191, 0.185);\n  /* box-shadow: 0px 1px 1px; */\n}\n.number-input {\n  /* border-radius: 4px; */\n  background-color: unset;\n  border: none;\n  text-align: right;\n  width: 100%;\n  border-bottom: 1px solid #409eff;\n}\n", ""]);

// exports
